import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=b6e71b58&scoped=true&lang=pug"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"
import style0 from "./h5.scss?vue&type=style&index=0&id=b6e71b58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e71b58",
  null
  
)

export default component.exports